<div *ngIf="isLoading | async" class="z-[60] bg-neutral-600 bg-opacity-90 h-full w-full fixed left-0 top-0">
	<div class="loader"></div>
</div>
